import DocumentsSection from '~/modules/identification/forms/Documents/components/DocumentSection/DocumentsSection.tsx';
import { TDocument } from '~/modules/identification/forms/Documents/types.ts';
import { Button } from '@mui/material';
import { FormButtonGroup } from '~/modules/processing-personal/PersonalDataApplicationForm/components/styled.ts';

interface IApplicationDocumentPreviewProps {
  handlePreview?: (id: number | string) => void;
  documents: TDocument[];
  current: number;
  onOptionSignature: () => void;
}

export const ApplicationDocumentPreviewRemoteBankingContacts = ({
  documents,
  handlePreview,
  current,
  onOptionSignature,
}: IApplicationDocumentPreviewProps) => {
  return (
    <>
      <DocumentsSection
        headerText="Перегляньте документи для підписання"
        documents={documents}
        blockId={3}
        isEditable={false}
        fetchPreview={handlePreview}
      />
      <FormButtonGroup>
        {(current === 2 || current === 4) && (
          <Button variant="contained" color="primary" onClick={onOptionSignature}>
            Підписати
          </Button>
        )}
      </FormButtonGroup>
    </>
  );
};
